import { render, staticRenderFns } from "./ModifyNutritionModal.vue?vue&type=template&id=efb952e4&scoped=true"
import script from "./ModifyNutritionModal.vue?vue&type=script&lang=js"
export * from "./ModifyNutritionModal.vue?vue&type=script&lang=js"
import style0 from "./ModifyNutritionModal.vue?vue&type=style&index=0&id=efb952e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb952e4",
  null
  
)

export default component.exports